import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { firstValueFrom } from 'rxjs';

export const AuthGuard: CanActivateFn = async ( route, state ) => {
  const oidc = inject( OidcSecurityService );

  try {
    const { isAuthenticated } = await firstValueFrom( oidc.checkAuth() );

    if( isAuthenticated ) {
      return true;
    }
  }
  catch {
    // Start the OIDC flow when the current authentication state cannot be resolved.
  }

  oidc.authorize();

  return false;
};
